export const SLOT_DEFS = [
  { id: "am1", start: "07:30", end: "09:10", startMinutes: 450, endMinutes: 550, period: "am" },
  { id: "am2", start: "09:30", end: "11:10", startMinutes: 570, endMinutes: 670, period: "am" },
  { id: "pm1", start: "13:30", end: "15:10", startMinutes: 810, endMinutes: 910, period: "pm" },
  { id: "pm2", start: "15:30", end: "17:10", startMinutes: 930, endMinutes: 1030, period: "pm" }
];

export const SYNDROMES = {
  reumato: { name: "Reumato-Orto", short: "Reumato", color: "teal" },
  obstetricia: { name: "Síndromes Obstétricas", short: "Obstétricas", color: "coral" },
  cirurgicas: { name: "Síndromes Cirúrgicas", short: "Cirúrgicas", color: "indigo" }
};

export const BLOCKS = [
  { number: 1, start: "2026-07-28", end: "2026-08-21", label: "1º bloco" },
  { number: 2, start: "2026-08-24", end: "2026-09-25", label: "2º bloco" },
  { number: 3, start: "2026-09-28", end: "2026-10-30", label: "3º bloco" },
  { number: 4, start: "2026-11-03", end: "2026-12-04", label: "4º bloco" }
];

// Rotação do 8º período confirmada pela turma: Ortopedia/Reumato,
// Ginecologia e Obstetrícia, Cirurgia. Pode ser ajustada no perfil.
export const DEFAULT_ROTATIONS = {
  A: { 2: "reumato", 3: "obstetricia", 4: "cirurgicas" },
  B: { 2: "obstetricia", 3: "cirurgicas", 4: "reumato" },
  C: { 2: "cirurgicas", 3: "reumato", 4: "obstetricia" }
};

export const ACADEMIC_EVENTS = {
  "2026-07-28": { title: "Início do 2º semestre letivo", kind: "academic" },
  "2026-08-15": { title: "Nossa Senhora da Boa Viagem", subtitle: "Feriado municipal", kind: "holiday", noClasses: true },
  "2026-08-22": { title: "Sábado letivo", subtitle: "A programação não consta na grade enviada", kind: "academic", specialSchedule: true },
  "2026-09-07": { title: "Independência do Brasil", subtitle: "Feriado", kind: "holiday", noClasses: true },
  "2026-10-10": { title: "Sábado letivo", subtitle: "A programação não consta na grade enviada", kind: "academic", specialSchedule: true },
  "2026-10-12": { title: "Nossa Senhora Aparecida", subtitle: "Feriado", kind: "holiday", noClasses: true },
  "2026-10-15": { title: "Dia do Professor", kind: "holiday", noClasses: true },
  "2026-11-02": { title: "Finados", subtitle: "Feriado", kind: "holiday", noClasses: true },
  "2026-11-15": { title: "Proclamação da República", subtitle: "Feriado", kind: "holiday", noClasses: true },
  "2026-11-20": { title: "Dia Nacional da Consciência Negra", subtitle: "Feriado", kind: "holiday", noClasses: true },
  "2026-12-04": { title: "Término do 4º bloco temático", kind: "academic" },
  "2026-12-07": { title: "OSCE", subtitle: "7 a 11 de dezembro", kind: "assessment" },
  "2026-12-08": { title: "Imaculada Conceição", subtitle: "Feriado municipal", kind: "holiday", noClasses: true },
  "2026-12-16": { title: "Exame Final Multiestratégia", subtitle: "16 e 17 de dezembro", kind: "assessment" },
  "2026-12-18": { title: "Encerramento das atividades acadêmicas", kind: "academic" }
};

const activity = (code, title, professor = "", location = "", kind = "class") => ({
  code,
  title,
  professor,
  location,
  kind,
  source: "main"
});

const gt = (syndrome, professor, location) => activity("GT", `Grupo tutorial · ${SYNDROMES[syndrome].short}`, professor, location, "gt");
const pl = (detail, professor, location) => activity("PL", detail, professor, location, "pl");
const th = (detail, professor, location) => activity("TH", detail, professor, location, "th");
const pe = (professor, location) => activity("PE", "Metodologias ativas", professor, location, "pe");
const tp = () => activity("TP", "Tempo protegido", "", "", "tp");
const placeholder = (accepts) => ({ kind: "placeholder", accepts, source: "main" });
const groups = (one, two, three, four) => ({ 1: one, 2: two, 3: three, 4: four });
const everyone = (event) => groups(event, event, event, event);

const REUMATO_GT = groups(
  gt("reumato", "Paula C", "Sala 206"),
  gt("reumato", "Rogério", "Sala 208"),
  gt("reumato", "Rita", "Sala 209"),
  gt("reumato", "Déborah", "Sala 211")
);

const OBSTETRICIA_GT = groups(
  gt("obstetricia", "Rafaela", "Sala 201"),
  gt("obstetricia", "Paulo Boy", "Sala 203"),
  gt("obstetricia", "Fernanda I", "Sala 204"),
  gt("obstetricia", "Adriana S", "Sala 205")
);

const CIRURGICAS_GT = groups(
  gt("cirurgicas", "Eduardo F", "Sala 101"),
  gt("cirurgicas", "Camilla F", "Sala 106"),
  gt("cirurgicas", "Nina", "Sala 202"),
  gt("cirurgicas", "Paulo Cruz", "Sala 210")
);

const FIXED = placeholder(["fixed"]);
const SPECIALTY = placeholder(["specialty"]);
const ANY_CLINIC = placeholder(["fixed", "specialty"]);

export const BASE_SCHEDULE = {
  reumato: {
    1: {
      am1: groups(pl("Laboratório", "Denise", "Lab."), pl("Patologia", "Carmona", "Patologia"), tp(), tp()),
      am2: groups(tp(), tp(), pl("Laboratório", "Denise", "Lab."), pl("Patologia", "Carmona", "Patologia")),
      pm1: REUMATO_GT,
      pm2: REUMATO_GT
    },
    2: { am1: everyone(FIXED), am2: everyone(FIXED), pm1: everyone(FIXED), pm2: everyone(FIXED) },
    3: { am1: everyone(SPECIALTY), am2: everyone(SPECIALTY), pm1: REUMATO_GT, pm2: REUMATO_GT },
    4: {
      am1: groups(tp(), tp(), th("Laboratório", "Marcos M", "Lab."), th("Simulação", "Luciano", "Simulação")),
      am2: groups(th("Laboratório", "Marcos M", "Lab."), th("Simulação", "Luciano", "Simulação"), tp(), tp()),
      pm1: everyone(pe("Silvana Eloi", "Metodologias Ativas · CEASC")),
      pm2: everyone(tp())
    },
    5: { am1: everyone(ANY_CLINIC), am2: everyone(ANY_CLINIC), pm1: everyone(ANY_CLINIC), pm2: everyone(ANY_CLINIC) }
  },
  obstetricia: {
    1: { am1: OBSTETRICIA_GT, am2: OBSTETRICIA_GT, pm1: everyone(SPECIALTY), pm2: everyone(SPECIALTY) },
    2: { am1: everyone(ANY_CLINIC), am2: everyone(ANY_CLINIC), pm1: everyone(FIXED), pm2: everyone(FIXED) },
    3: {
      am1: everyone(SPECIALTY),
      am2: everyone(SPECIALTY),
      pm1: everyone(tp()),
      pm2: everyone(pe("Eliana Horta", "Metodologias Ativas · CEASC"))
    },
    4: {
      am1: groups(pl("Laboratório", "Denise", "Lab."), pl("Patologia", "Carmona", "Patologia"), th("Laboratório", "Paulo Boy", "Lab."), th("Simulação", "Mariana P", "Simulação")),
      am2: groups(th("Laboratório", "Paulo Boy", "Lab."), th("Simulação", "Mariana P", "Simulação"), pl("Laboratório", "Denise", "Lab."), pl("Patologia", "Carmona", "Patologia")),
      pm1: OBSTETRICIA_GT,
      pm2: OBSTETRICIA_GT
    },
    5: { am1: everyone(ANY_CLINIC), am2: everyone(ANY_CLINIC), pm1: everyone(ANY_CLINIC), pm2: everyone(ANY_CLINIC) }
  },
  cirurgicas: {
    1: { am1: CIRURGICAS_GT, am2: CIRURGICAS_GT, pm1: everyone(pe("Maria Turci", "Metodologias Ativas · CEASC")), pm2: everyone(tp()) },
    2: { am1: everyone(SPECIALTY), am2: everyone(SPECIALTY), pm1: everyone(FIXED), pm2: everyone(FIXED) },
    3: { am1: everyone(SPECIALTY), am2: everyone(SPECIALTY), pm1: CIRURGICAS_GT, pm2: CIRURGICAS_GT },
    4: { am1: everyone(SPECIALTY), am2: everyone(SPECIALTY), pm1: everyone(SPECIALTY), pm2: everyone(SPECIALTY) },
    5: {
      am1: groups(pl("Laboratório · Itapoã", "Luana", "Lab."), pl("Patologia · Itapoã", "Dourado", "Patologia"), th("Simulação · Itapoã", "Camilla F", "Simulação"), th("Simulação · Itapoã", "M. Cecília", "Simulação")),
      am2: groups(th("Simulação · Itapoã", "Camilla F", "Simulação"), th("Simulação · Itapoã", "M. Cecília", "Simulação"), pl("Laboratório · Itapoã", "Luana", "Lab."), pl("Patologia · Itapoã", "Dourado", "Patologia")),
      pm1: everyone(tp()),
      pm2: everyone(tp())
    }
  }
};

const clinic = ({ day, period, code, title, professor, location, regional = "", source }) => ({
  day,
  period,
  code,
  title,
  professor,
  location,
  regional,
  source,
  kind: "clinic"
});

const fixed = (day, period, number, title, professor, location, regional = "") => clinic({
  day,
  period,
  code: `AF${number}`,
  title,
  professor,
  location,
  regional,
  source: "fixed"
});

export const FIXED_CLINICS = {
  2: {
    A: {
      1: fixed(2, "am", 1, "Pediatria", "Fernanda Ribeiro", "Ambulatório da Igreja do Carmo", "Sion"),
      2: fixed(2, "pm", 2, "Pediatria", "Letícia Linhares", "Centro de Saúde Boa Vista", "Leste"),
      3: fixed(2, "pm", 3, "Pediatria", "Marina Araújo", "Ambulatório da Igreja do Carmo", "Sion"),
      4: fixed(2, "pm", 4, "Clínica Médica", "Eduardo Cordeiro", "Centro de Saúde Santa Terezinha", "Pampulha"),
      5: fixed(2, "pm", 5, "Clínica Médica", "Henrique Barros", "Centro de Saúde Lagoa", "Venda Nova"),
      6: fixed(5, "am", 6, "Cirurgia", "Pablo Hubner", "CEASC")
    },
    B: {
      1: fixed(2, "am", 1, "Pediatria", "Cristiano Bento", "Centro de Saúde São Francisco", "Pampulha"),
      2: fixed(2, "pm", 2, "Pediatria", "Kátia Bueno", "Centro de Saúde Santa Amélia", "Pampulha"),
      3: fixed(2, "pm", 3, "Pediatria", "Gabriele Rezende", "Centro de Saúde João Vital", "Nordeste"),
      4: fixed(2, "pm", 4, "Clínica Médica", "Yara Santos", "Ambulatório da Igreja do Carmo", "Sion"),
      5: fixed(2, "pm", 5, "Cirurgia", "Camila Godinho", "CEASC")
    },
    C: {
      1: fixed(2, "am", 1, "Pediatria", "Giovanna Fonseca", "Centro de Saúde Santa Rosa", "Pampulha"),
      2: fixed(2, "pm", 2, "Pediatria", "Fernanda Ribeiro", "Centro de Saúde Santa Rosa", "Pampulha"),
      3: fixed(2, "pm", 3, "Cirurgia", "Leonardo Gasbarro", "CEASC"),
      4: fixed(2, "pm", 4, "Cirurgia", "Daniela Alves", "CEASC"),
      5: fixed(2, "pm", 5, "Clínica Médica", "Miguel Ângelo", "Ambulatório da Igreja do Carmo", "Sion")
    }
  },
  3: {
    A: {
      1: fixed(2, "am", 1, "Pediatria", "Fernanda Ribeiro", "Centro de Saúde Confisco", "Pampulha"),
      2: fixed(2, "pm", 2, "Pediatria", "Letícia Linhares", "Centro de Saúde Boa Vista", "Leste"),
      3: fixed(2, "pm", 3, "Pediatria", "Marina Araújo", "Ambulatório da Igreja do Carmo", "Sion"),
      4: fixed(2, "pm", 4, "Cirurgia", "Leonardo Gasbarro", "CEASC"),
      5: fixed(2, "pm", 5, "Cirurgia", "Daniela Alves", "CEASC"),
      6: fixed(2, "pm", 6, "Clínica Médica", "Miguel Ângelo", "Ambulatório da Igreja do Carmo", "Sion")
    },
    B: {
      1: fixed(2, "am", 1, "Pediatria", "Cristiano Bento", "Centro de Saúde São Francisco", "Pampulha"),
      2: fixed(2, "pm", 2, "Pediatria", "Kátia Bueno", "Centro de Saúde Santa Amélia", "Pampulha"),
      3: fixed(2, "pm", 3, "Pediatria", "Gabriele Rezende", "Centro de Saúde Vila Maria", "Nordeste"),
      4: fixed(2, "pm", 4, "Cirurgia", "Camila Godinho", "CEASC"),
      5: fixed(2, "pm", 5, "Clínica Médica", "Yara Santos", "Ambulatório da Igreja do Carmo", "Sion")
    },
    C: {
      1: fixed(2, "am", 1, "Pediatria", "Giovanna Fonseca", "Centro de Saúde Santa Rosa", "Pampulha"),
      2: fixed(2, "pm", 2, "Pediatria", "Fernanda Ribeiro", "Centro de Saúde Santa Rosa", "Pampulha"),
      3: fixed(2, "pm", 3, "Clínica Médica", "Eduardo Cordeiro", "Centro de Saúde Santa Terezinha", "Pampulha"),
      4: fixed(2, "pm", 4, "Clínica Médica", "Henrique Barros", "Centro de Saúde Lagoa", "Venda Nova"),
      5: fixed(5, "am", 5, "Cirurgia", "A contratar", "CEASC")
    }
  }
};

// Os blocos 3 e 4 compartilham a mesma tabela de ambulatório fixo.
FIXED_CLINICS[4] = FIXED_CLINICS[3];

const specialty = (day, period, ae, service, professor, location, regional = "") => clinic({
  day,
  period,
  code: `AE${ae} · ${service}`,
  title: service === "ORT" ? "Ortopedia" : service === "REU" ? "Reumatologia" : service.startsWith("CIR") ? "Cirurgia" : "Saúde da mulher",
  professor,
  location,
  regional,
  source: "specialty"
});

export const SPECIALTY_CLINICS = {
  reumato: {
    1: [specialty(3, "am", 1, "ORT", "Marcos M", "CEASC"), specialty(5, "am", 1, "REU", "Paulo C", "CEASC")],
    2: [specialty(5, "am", 2, "ORT", "Gabriel A", "CEASC"), specialty(5, "pm", 2, "REU", "Paulo C", "CEASC")],
    3: [specialty(3, "am", 3, "ORT", "Luciano", "CEASC"), specialty(5, "am", 3, "REU", "Ursula", "CEASC")],
    4: [specialty(3, "am", 4, "REU", "Ursula", "CEASC"), specialty(5, "am", 4, "ORT", "Luciano", "CEASC")],
    5: [specialty(3, "am", 5, "REU", "Déborah", "CEASC"), specialty(5, "pm", 5, "ORT", "Gabriel A", "CEASC")]
  },
  cirurgicas: {
    1: [specialty(3, "am", 1, "CIR1", "Mário", "CEASC"), specialty(4, "am", 1, "CIR2", "Mário", "CEASC")],
    2: [specialty(3, "am", 2, "CIR1", "Daniela Alves", "CEASC"), specialty(5, "pm", 2, "CIR2", "Walter Lozada", "CEASC")],
    3: [specialty(4, "am", 3, "CIR1", "João Cláudio", "CEASC"), specialty(4, "pm", 3, "CIR2", "Fabiana B", "CEASC")],
    4: [specialty(2, "am", 4, "CIR1", "Fábio H", "CEASC"), specialty(4, "pm", 4, "CIR2", "Fernanda C P", "CEASC")],
    5: [specialty(3, "am", 5, "CIR1", "Camila Godinho", "CEASC"), specialty(4, "am", 5, "CIR2", "Fabiana B", "CEASC")]
  },
  // Cada AE tem dois sub-ambulatórios (GOB1/GOB2) que entram juntos, como em Reumato/Cirurgia.
  obstetricia: {
    1: [specialty(1, "pm", 1, "GOB1", "Lívia Nascimento", "Centro de Saúde Felicidade II", "Norte"), specialty(3, "am", 1, "GOB2", "Mariana Parreiras", "Centro de Saúde Padre Fernando", "Nordeste")],
    2: [specialty(3, "am", 2, "GOB1", "Adriana Sarubbi", "Ambulatório da Igreja do Carmo", "Sion"), specialty(5, "am", 2, "GOB2", "Lívia Nascimento", "Centro de Saúde 1º de Maio", "Norte")],
    3: [specialty(1, "pm", 3, "GOB1", "Ana Christina Lobato", "Centro de Saúde Urucuia", "Barreiro"), specialty(3, "am", 3, "GOB2", "Ana Christina Lobato", "Centro de Saúde Urucuia", "Barreiro")],
    4: [specialty(1, "pm", 4, "GOB1", "Alexon Melgaço", "Centro de Saúde Vila Maria", "Nordeste"), specialty(3, "am", 4, "GOB2", "Alexon Melgaço", "Centro de Saúde Vila Maria", "Nordeste")],
    5: [specialty(1, "pm", 5, "GOB1", "Paulo Boy", "Centro de Saúde Novo Aarão Reis", "Norte"), specialty(2, "am", 5, "GOB2", "Ana Christina Lobato", "Centro de Saúde Urucuia", "Barreiro")],
    6: [specialty(1, "pm", 6, "GOB1", "Adriana Sarubbi", "Ambulatório da Igreja do Carmo", "Sion"), specialty(5, "pm", 6, "GOB2", "Ana Christina Lobato", "Centro de Saúde Urucuia", "Barreiro")],
    7: [specialty(2, "am", 7, "GOB1", "Mariana Parreiras", "Centro de Saúde Piratininga", "Venda Nova"), specialty(5, "pm", 7, "GOB2", "Raquel Antunes", "Centro de Saúde Piratininga", "Venda Nova")],
    8: [specialty(2, "am", 8, "GOB1", "Raquel Antunes", "Ambulatório da Igreja do Carmo", "Sion"), specialty(3, "am", 8, "GOB2", "Rafaela Scheffer", "Centro de Saúde Etelvina Carneiro", "Norte")],
    9: [specialty(3, "am", 9, "GOB1", "Mirella Marques", "Centro de Saúde Piratininga", "Venda Nova"), specialty(1, "pm", 9, "GOB2", "Mirella Marques", "Centro de Saúde Serrano", "Pampulha")]
  }
};

export const SOURCE_INFO = {
  schedule: "Horário do 8º período 2026/02 — Síndromes Clínicas",
  calendar: "Calendário acadêmico 2026 — Medicina BH, 1º ao 8º período",
  warning: "Os documentos informam que horários e unidades estão sujeitos a modificações."
};
